module.exports = __webpack_public_path__ + "img/binaris.c99e71eb.svg";